<template>
  <div>
    <h5>本人確認書類の提出</h5>

    <template v-if="String(user.identification_flg) == '3'">
      <div class="form-group">
        <div class="col-sm-12 px-1">
          本人確認が完了しました。
        </div>
      </div>
    </template>
    <template v-if="String(user.identification_flg) == '2'">
      <div class="form-group">
        <div class="col-sm-12 px-1">
          本人確認を認証できませんでした。<br>
          再提出をお願いいたします。
        </div>
      </div>
    </template>
    <template v-if="String(user.identification_flg) == '1'">
      <div class="form-group">
        <div class="col-sm-12 px-1">
          本人確認書類申請中です。
          今しばらくお待ちください。
        </div>
      </div>
    </template>
    <template v-else>
      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label for="" class="mt-4 col-sm-12 control-label">本人確認書類 (２つまで)  <span class="required_mark">必須</span></label>

              <div class="my-4">
                <div>
                  <label for="">1つ目のファイル</label>
                  <input type="file" v-model="identificationForm.form1" id="file1" class="file_input" accept=".jpg,.png,.pdf" ref="file1" @change="fileSelected1" v-bind:class="{ error_input: identificationForm.errors.file1.length > 0 }">
                </div>
                <div>
                  <label for="">2つ目のファイル</label>
                  <input type="file" v-model="identificationForm.form2" id="file2" class="file_input" accept=".jpg,.png,.pdf" ref="file2" @change="fileSelected2">
                </div>
                <div v-if="identificationForm.errors.file1.length > 0">
                  <div class="error-text" v-for="(item, index) in identificationForm.errors.file1" :key="index">{{ item }}</div>
                </div>
              </div>

              <div class="row">
                  <span class="col-sm-12 mt-0 mr-1 ml-1 mb-3">※以下のいずれかの書類のコピーが必要となります。<br><br>
                  免許証（裏に特記事項がある場合は、表、裏の二枚）<br>
                  健康保険証<br>
                  パスポート<br>
                  住民基本台帳カード　「顔写真」入りでお名前・住所（現住居）・生年月日が記載されているもの。）<br>
                  個人番号カード　「顔写真」のある表面のみのコピーが必要です。<br>
                  </span>
              </div>

          </div>
      </div>
      <div class="form-group">
          <div class="b100 col-sm-12">
            <button @click="checkForm" type="button" class="bs100 btn btn-primary">提出</button>
          </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: { 
    user: Object
  },
  data() {
		const status = [
      {"no":"0","name":"未完了"},
      {"no":"1","name":"申請中"},
      {"no":"2","name":"エラー"},
      {"no":"3","name":"完了"},
    ];
    return {
      fileInfo1: '',
      fileInfo2: '',
      isError: false,
      identificationForm: {
        errors: {
          file1: [],
        },
        file1: null,
        file2: null,
      },
    }
  },
  methods: {
    fileSelected1(e) {
      console.log(e);
      this.fileInfo1 = e.target.files[0];
    },
    fileSelected2(e) {
      console.log(e);
      this.fileInfo2 = e.target.files[0];
    },
    checkForm: function(e) {
      console.log(this.user);
      this.isError = false;
			this.identificationForm.errors.file1 = [];
      var file1 = document.getElementById("file1").value;
      var file2 = document.getElementById("file2").value;
      if(file1 == "" && file2 == "") {
        this.isError = true;
        this.identificationForm.errors.file1.push('ファイルが選択されていません');
      }
			if (!this.isError) {
				let formData = new FormData();
        formData.append('fileInfo1', this.fileInfo1); 
        formData.append('fileInfo2', this.fileInfo2); 
				this.$store.dispatch('auth/identification', {
					formData: formData,
					headers: {
						"Content-Type": "multipart/form-data"
					},
				}).then(res => {
					this.user.identification_flg = 1;
          window.scrollTo({
            top: 0,
          });
				}, error => {
					console.log('error発生');
					console.log(error);
					this.$nextTick(() => {
            window.scrollTo({
              top: 0,
            });
					});
				});
				return false;
			} else {
				window.scrollTo({
					top: 0,
				});
			}
      return false;
    },
  },

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mypage/seller/identification.vue